import React, { useState, useEffect, useRef } from 'react';
import DefaultImg from './../../../../image/default/recruit.png'
import Styles from './styles.module.css';
import Title from './../title/index';
import Pager from './../pager/index';
import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/splide/css';
import { IoImageOutline } from "react-icons/io5";
import { summaryData } from 'src/type';

type RecruitPageHeaderProps = {
  companyId: string;
  summary: summaryData;
  recruitStatus: boolean;
  // 求人編集のプレビュー時のみ true。未入力欄に例文（灰色）を出す。
  // 公開求人ページからは渡されないため、応募者には従来どおり何も出ない。
  preview?: boolean;
  // 求人編集で選択直後（アップロード前）の画像を即時プレビューするための
  // { 画像ID: ローカル blob URL } マップ。公開ページからは渡されない。
  localImages?: Record<string, string>;
};

const RecruitPageHeader: React.FC<RecruitPageHeaderProps> = React.memo(({ companyId, summary, recruitStatus, preview, localImages }) => {

  const [ storeImages, setStoreImages ] = useState<string[]>(summary.images);
  const [ time, setTime ] = useState<number>(0);

  useEffect(() => {
    setStoreImages(summary.images);

    const time = new Date().getTime();
    setTime(time);
  }, [ summary.images ]);

  const carouselRef = useRef<any>(null);
  const [ currentIndex, setCurrentIndex ] = useState(0);

  // 選択直後（アップロード前）はローカル blob を、そうでなければ resize 済み画像を表示
  const imageSrc = (id: string) =>
    localImages?.[id] ??
    `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/styles%2Fresize_images%2F${id}_1080x1080?alt=media&token=?${time}`;

  return (
    <>
    <div className={Styles.header_title}>
      {companyId && (
        <img src={
          `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${companyId}_200x200?alt=media&token=?${time}`} alt=''
          onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = DefaultImg;
          }}/>
      )}
      <h2>{summary.name}</h2>
    </div>
    
    <div className={Styles.header}>

      {summary.title
        ? <h1>{summary.title}</h1>
        : <h1 className={preview ? Styles.previewPlaceholder : undefined}>
            {preview ? "例）「なりたい」を、ちゃんと叶えるサロン" : ""}
          </h1>}

      {recruitStatus && (
      <>
        <Pager
          index={currentIndex}
          total={preview && storeImages.length === 0 ? 5 : storeImages.length}
          onPrev={() => carouselRef.current?.splide.go('<')}
          onNext={() => carouselRef.current?.splide.go('>')} />

        <div className={Styles.header_image}>
          <Splide
            ref={carouselRef}
            aria-label=""
            options={{
              perPage: 1,
              arrows: false,
              pagination: false,
            }}
            onMove={(splide, newIndex) => {
              setCurrentIndex(newIndex);
            }}>
            {preview && storeImages.length === 0 ?
              [0, 1, 2, 3, 4].map((n) => (
                <SplideSlide key={n}>
                  <div className={Styles.noImage}>
                    <IoImageOutline className={Styles.noImageIcon} />
                    <span>店舗写真 {n + 1}</span>
                  </div>
                </SplideSlide>
              ))
            : <></> }
            {1 <= storeImages.length ?
              <SplideSlide>
                <img className={Styles.header_image_img} src={imageSrc(storeImages[0])}
                  alt="美容室 求人 memorii works" />
              </SplideSlide>
            : <></> }
            {2 <= storeImages.length ?
              <SplideSlide>
                <img className={Styles.header_image_img} src={imageSrc(storeImages[1])}
                  alt="美容室 求人 memorii works" />
              </SplideSlide>
            : <></> }
            {3 <= storeImages.length ?
              <SplideSlide>
                <img className={Styles.header_image_img} src={imageSrc(storeImages[2])}
                  alt="美容室 求人 memorii works" />
              </SplideSlide>
            : <></> }
            {4 <= storeImages.length ?
              <SplideSlide>
                <img className={Styles.header_image_img} src={imageSrc(storeImages[3])}
                  alt="美容室 求人 memorii works" />
              </SplideSlide>
            : <></> }
            {5 <= storeImages.length ?
              <SplideSlide>
                <img className={Styles.header_image_img} src={imageSrc(storeImages[4])}
                  alt="美容室 求人 memorii works" />
              </SplideSlide>
            : <></> }
          </Splide>
        </div>
      </> )}

      <div className={Styles.features_title}>
        <Title
          title={"特徴"}
          desc={"サロンの特徴を100文字で説明"} />
      </div>

      {summary.companyPr
        ? <p className={Styles.features}>{summary.companyPr}</p>
        : <p className={preview ? `${Styles.features} ${Styles.previewPlaceholder}` : Styles.features}>
            {preview ? "例）2000年創業、都内に5店舗。20代スタッフが中心で、未経験から3年でスタイリストを目指せる教育体制が強みです。産休・育休の取得実績も豊富です。" : ""}
          </p>}

    </div>
    </>
  );
});

export default RecruitPageHeader;

